"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModerationStatusResponseModelWarningStatus = void 0;
exports.ModerationStatusResponseModelWarningStatus = {
    Warning: "warning",
    WarningCleared: "warning_cleared",
};
